import { closeToast, showDialog, showLoadingToast } from 'vant'

export const ENV = 'PRO'
// export const ENV = 'TEST'

// 格式化日期
export const formatDate = (source, format) => {
  if (!source) {
    source = new Date()
  }
  source = isNaN(source) ? source : new Date(source)
  var o = {
    'M+': source.getMonth() + 1, // 月份
    'd+': source.getDate(), // 日
    'H+': source.getHours(), // 小时
    'm+': source.getMinutes(), // 分
    's+': source.getSeconds(), // 秒
    'q+': Math.floor((source.getMonth() + 3) / 3), // 季度
    'f+': source.getMilliseconds(), // 毫秒
  }
  if (/(y+)/.test(format)) {
    format = format.replace(
      RegExp.$1,
      (source.getFullYear() + '').substr(4 - RegExp.$1.length)
    )
  }
  for (var k in o) {
    if (new RegExp('(' + k + ')').test(format)) {
      format = format.replace(
        RegExp.$1,
        RegExp.$1.length === 1
          ? o[k]
          : ('00' + o[k]).substr(('' + o[k]).length)
      )
    }
  }
  return format
}

// 存储
export const setStorage = (key, value) => {
  if (typeof value == 'object') {
    localStorage.setItem(key, JSON.stringify(value))
  } else {
    localStorage.setItem(key, value)
  }
}
// 读取
export const getStorage = (key) => {
  let value = localStorage.getItem(key)
  try {
    value = JSON.parse(value)
  } catch (error) { }
  return value
}
// 清空
export const clearStorage = (key) => {
  localStorage.removeItem(key)
}

// 存储session
export const setSession = (key, value) => {
  if (typeof value == 'object') {
    sessionStorage.setItem(key, JSON.stringify(value))
  } else {
    sessionStorage.setItem(key, value)
  }
}
// 读取session
export const getSession = (key) => {
  let value = sessionStorage.getItem(key)
  try {
    value = JSON.parse(value)
  } catch (error) { }
  return value
}

// 获取当前Token
export const getToken = () => {
  let uinfo = getSession('uinfo')
  let token = ''
  try {
    token = uinfo.token
  } catch (error) { }
  return token
}
// 弹出错误提示弹窗
export const showFailMessage = (message = '') => {
  showDialog({
    message,
    confirmButtonText: '我知道啦',
    confirmButtonColor: '#1890ff',
  })
}
// 加载中
export const showLoading = (message = '加载中', forbidClick = true) => {
  showLoadingToast({
    message,
    forbidClick,
  })
}
// 隐藏加载中
export const hideLoading = () => {
  closeToast(true)
}

export const isTextEmpty = (text) => {
  text = `${text}`
  return text && text != 'undefined' ? String(text).trim().length == 0 : true
}

// 获取用户的权限信息，需要先在界面中使用接口鉴权
export const getTTSetting = () => {
  return new Promise((resolve, reject) => {
    tt.getSetting({
      success: (res) => {
        resolve(res.authSetting)
      },
      fail: (err) => {
        resolve({})
      },
    })
  })
}

// 获取uuid
export const uuid = () => {
  var s = []
  var hexDigits = '0123456789abcdef'
  for (var i = 0; i < 36; i++) {
    s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1)
  }
  s[14] = '4' // bits 12-15 of the time_hi_and_version field to 0010
  s[19] = hexDigits.substr((s[19] & 0x3) | 0x8, 1) // bits 6-7 of the clock_seq_hi_and_reserved to 01
  s[8] = s[13] = s[18] = s[23] = '-'

  var uuid = s.join('')
  if (
    location.href.indexOf('test.patrol.h5.xiaoqiandao.com') > -1 ||
    ENV == 'TEST'
    // || location.href.indexOf('192.168') > -1
  ) {
    return `test_${uuid}`
  } else {
    return uuid
  }
}

// 处理路由的返回，如果当前已经没有上级了，
export const back = (router, num = -1) => {
  let last_path = getSession('last_path')
  if (last_path == '/') {
    router.replace('/index')
  } else {
    router.go(num)
  }
}

// 深拷贝
export const deepCopy = (val) => {
  return JSON.parse(JSON.stringify(val))
}

export const getQueryString = (name) => {
  var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i')
  var r = window.location.search.substr(1).match(reg)
  if (r != null) {
    return unescape(r[2])
  }
  return null
}


export function detectDevice() {
  // 获取用户代理字符串  
  var userAgent = navigator.userAgent || navigator.vendor || window.opera;

  // 简单的移动端判断  
  // 注意：这里只列出了一些常见的移动端浏览器用户代理，可能需要根据实际情况进行扩展  
  var mobileAgents = ["Android", "iPhone", "SymbianOS", "Windows Phone", "iPad", "iPod"];

  // 遍历数组，检查用户代理是否包含移动端标识  
  for (var i = 0; i < mobileAgents.length; i++) {
    if (userAgent.indexOf(mobileAgents[i]) > -1) {
      return "Mobile"; // 是手机端  
    }
  }

  return "Desktop"; // 不是手机端，默认为PC端  
}